module.exports = __webpack_public_path__ + "img/2_uk.101519f3.svg";